require('./dataItemsGroup.i18n.json');
require('./dataItemsGroup.tpl.html');
require('./dataItemsGroupController.js');
require('./uiDataItemDragManager.js');
require('./uiDataItemsGroupDragManager.js');

const DataItemsGroupComponent = {
    templateUrl: '/configuration/dataSetEditor/content/dataItems/dataItemsGroup/dataItemsGroup.tpl.html',
    controller: 'dataItemsGroupController',
    bindings: {
        datasetName: '<',
        dataitemsGroup: '<',
        isProductOrFieldDependent: '<',
        isDeleteEnabled: '<',
        notifyDeleteClick: '&',
        notifyDataItemsGroupSelectedOrUnselected: '&',
        notifyDataItemSelectedOrUnselected: '&',
        notifyTextInputFocused: '&',
        timeLastModified: '<',
        groupIndex: '<'
    }
};

angular.module('ums.configuration')
    .component('dataitemsGroup', DataItemsGroupComponent);
